import DOMPurify from 'dompurify';

const HTML_SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'p',
    'br',
    'strong',
    'b',
    'em',
    'i',
    'u',
    's',
    'a',
    'ul',
    'ol',
    'li',
    'h1',
    'h2',
    'h3',
    'h4',
    'blockquote',
    'span',
    'div',
    'sub',
    'sup',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
};

export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) {
    return '';
  }
  return DOMPurify.sanitize(html, HTML_SANITIZE_CONFIG) as unknown as string;
}

export function plainTextFromHtml(html: string | null | undefined): string {
  if (!html) {
    return '';
  }
  const tmp = document.createElement('div');
  tmp.innerHTML = sanitizeHtml(html);
  return (tmp.textContent ?? '').replace(/\u00a0/g, ' ').trim();
}

export function hasHtmlContent(html: string | null | undefined): boolean {
  return plainTextFromHtml(html).length > 0;
}

export function excerptFromHtml(
  html: string | null | undefined,
  maxLength = 150
): string | undefined {
  const text = plainTextFromHtml(html);
  if (!text) {
    return undefined;
  }
  return text.length > maxLength ? `${text.slice(0, maxLength - 3)}...` : text;
}
